import { z } from 'zod';
import { paginationQueryResponse } from './pagination';

const ImageSchema = z.nullable(
  z.object({
    url: z.nullable(z.string()),
  }),
);

const TeacherProfileSchema = z.object({
  displayName: z.nullable(z.string()),
  profilePicture: ImageSchema,
});

const lessonProgresses = z.nullable(
  z.array(
    z.object({
      progress_status: z.nullable(z.string()),
      current_second: z.nullable(z.number()),
    }),
  ),
);

const SkillLevelSchema = z.object({
  name: z.nullable(z.string()),
});

export const trendingSeriesSchema = z.object({
  data: z.array(
    z.object({
      documentId: z.nullable(z.string()),
      title: z.nullable(z.string()),
      description: z.nullable(z.string()),
      numberOfVideos: z.nullable(z.number()),
      trailerPlaybackId: z.nullable(z.string()),
      trailerPlaybackToken: z.nullable(z.string()),
      duration: z.nullable(z.number()),
      isPurchasable: z.nullable(z.boolean()),
      thumbnail: ImageSchema,
      teacherProfiles: z.nullable(z.array(TeacherProfileSchema)),
      skillLevel: z.nullable(SkillLevelSchema),
      topics: z.nullable(z.array(z.object({ name: z.nullable(z.string()) }))),
      musicalGenres: z.nullable(
        z.array(
          z.object({
            name: z.nullable(z.string()),
          }),
        ),
      ),
      lessons: z.nullable(
        z.array(
          z.object({
            title: z.nullable(z.string()),
            duration: z.nullable(z.number()),
            lessonProgresses,
          }),
        ),
      ),
    }),
  ),
  pagination: paginationQueryResponse,
});

export type TrendingSeries = z.infer<typeof trendingSeriesSchema>;
export type LessonProgresses = z.infer<typeof lessonProgresses>;
